import React from "react";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025.
 */
var FooterCopyright = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "fr-footer__bottom-copy" }, children);
};
export default FooterCopyright;
